module.exports = __webpack_public_path__ + "assets/images/project/icons/location.svg?v=79f2e6e9";